module.exports = __webpack_public_path__ + "media/images/avatar-c0edcc78ebdfae09959debaa33892afe.png";